import { CargoStoreList } from '../models';

const getStoresEnabled = (stores: CargoStoreList) =>
  stores.filter(store => store?.isEnabled);

export const cargoFormHelper = {
  getStoresEnabled,
} as const;
